const mediaItems = [
  {
    title: '顶流男星密会神秘女子完整视频',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20night%20street%20scene%20with%20blurred%20silhouettes%20under%20warm%20streetlamps%2C%20dramatic%20film%20noir%20aesthetic%2C%20golden%20amber%20lighting%2C%20mysterious%20urban%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20luxury%20hotel%20entrance%20at%20night%2C%20cinematic%20composition&width=640&height=360&seq=media-cover-01&orientation=landscape',
    duration: '08:42',
    views: '128.6万',
    tag: '独家爆料',
  },
  {
    title: '知名女星前夫实锤录音全记录',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20scene%20with%20warm%20golden%20stage%20spotlight%20on%20dark%20background%2C%20cinematic%20film%20noir%20style%2C%20soft%20amber%20glow%2C%20theatrical%20atmosphere%2C%20mysterious%20elegant%20mood%2C%20shallow%20depth%20of%20field%2C%20artistic%20composition&width=640&height=360&seq=media-cover-02&orientation=landscape',
    duration: '12:18',
    views: '96.3万',
    tag: '实锤证据',
  },
  {
    title: '综艺节目后台冲突现场画面',
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20backstage%20scene%20with%20warm%20golden%20lighting%2C%20cinematic%20tension%2C%20abstract%20silhouettes%20in%20contrast%2C%20theatrical%20behind%20the%20scenes%20atmosphere%2C%20amber%20and%20deep%20shadow%20tones%2C%20editorial%20documentary%20style%2C%20artistic%20composition&width=640&height=360&seq=media-cover-03&orientation=landscape',
    duration: '05:33',
    views: '87.1万',
    tag: '现场直击',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-lg">
            <i className="ri-play-circle-line text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩视频</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">黑料在线播放 · 精选热门黑料视频正片</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-background-300 transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} - 黑料在线视频`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded bg-foreground-950/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-foreground-950 group-hover:text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}